import CommissionManagementReportDetails from './CommissionManagementReportDetails';

export default CommissionManagementReportDetails;
